
define(['jquery', 'underscore', 'app-common/template/confirm-dialog.htm'], function($, _, dialogTemplate) {
  return {
    init: function(template, buttons, noIcon, data, title) {
      var text;
      if (title == null) {
        title = '';
      }
      if (data != null) {
        text = _.template(template, data);
      } else {
        text = template;
      }
      $('body').append(_.template(dialogTemplate, {
        text: text,
        buttons: buttons
      }));
      $('#confirm-dialog').css('margin-top', -Math.floor($('#confirm-dialog').height() / 2) + 'px');
      $('#confirm-dialog').modal().on('hidden', function() {
        return $('#confirm-dialog').remove();
      });
      $('.confirm-cancel').click(function() {
        return $('#confirm-dialog').modal('hide');
      });
      if (noIcon) {
        $('.modal .modal-title').remove();
      }
      if (title != null ? title.length : void 0) {
        $('.modal .modal-title').html(title);
      }
      return $('.confirm-ok').focus();
    },
    hide: function() {
      return $('#confirm-dialog').modal('hide');
    }
  };
});
